module.exports = __webpack_public_path__ + "img/6065ca6.jpg";